import { Box, Chip, Drawer } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "../../../hooks";
import useResponsive from "../../../hooks/useResponsive";
import { useDrawerStore } from "../../../hooks/useDrawerStore";
import { NavSection } from "./NavSection";
import { HeaderView } from "../Header/Header";
import { useNavSectionStore } from "../../../hooks/useNavSectionStore";
import logo from "../../../assets/image/nuevo_cfe_logo.png";

const NAV_WIDTH = 280;

export const Nav: React.FC<any> = ({
  openNav,
  onCloseNav,
}): JSX.Element | any => {
  const { user } = useAuthStore();

  const isDesktop = useResponsive("up", "lg", "");
  const { drawerOpen, openDrawer } = useDrawerStore();
  const { navOpen } = useNavSectionStore();
  const { pathname } = useLocation();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const withNavOpen = navOpen ? NAV_WIDTH : 0;

  const renderContent = (
    <>
      <Box
        sx={{
          display: "flex",
          minHeight: 104,
          px: 3,
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(135deg, #014DDF 0%, #0A229C 100%)",
          backgroundImage:
            "radial-gradient(circle at 16% 22%, rgba(0, 217, 255, 0.3), transparent 34%), linear-gradient(135deg, #014DDF 0%, #0A229C 100%)",
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Focus - Centro de Formación"
          sx={{ width: 176, height: "auto", display: "block" }}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5, mb: 1 }}>
        <Chip
          size="small"
          label={user.userType}
          sx={{
            px: 1,
            color: "primary.dark",
            backgroundColor: "primary.light",
            fontSize: 12,
          }}
        />
      </Box>
      <NavSection />
      <Box sx={{ flexGrow: 1 }} />
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { lg: 0 }, width: { lg: withNavOpen } }}
    >
      <HeaderView />
      {/* <Drawer open variant="permanent" 
              PaperProps={{ sx: { width: withNavOpen, bgcolor: 'background.default', borderRightStyle: 'dashed'} }}
            >
              { renderContent }
            </Drawer> */}
      {isDesktop ? (
        navOpen ? (
          <Drawer
            open
            variant="permanent"
            PaperProps={{
              sx: {
                width: withNavOpen,
                bgcolor: "background.paper",
                borderRight: "1px solid",
                borderColor: "divider",
              },
            }}
          >
            {renderContent}
          </Drawer>
        ) : null
      ) : (
        <Drawer
          open={drawerOpen}
          onClose={() => openDrawer(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: "background.paper",
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
};
